<template>
    <div>
        <div v-if="serviceType == 'CG'">
            <!-- 采购 -->
            <div class="summary-title">》工作内容</div>
            <Form :label-width="100" :itemMarginBottom="0">
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="交货时间" prop="deliveryTime">
                            <span>{{info.deliveryTime | ymdL}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="交货地点" prop="deliveryAddr">
                            <span>{{info.deliveryAddr}}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="客户验收人" prop="acceptor">
                            <span>{{info.acceptor}}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="结算方式" prop="settleType">
                            <span>{{info.settleType}}</span>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12" v-for="(item, index) in info.purchaseList" :key="index">
                        <FormItem label="商品名称" prop="merchName">
                            <span>{{item.merchName}}</span>
                        </FormItem>
                        <FormItem label="型号" prop="merchModel">
                            <span>{{item.merchModel}}</span>
                        </FormItem>
                        <FormItem label="数量" prop="num">
                            <span>{{item.num}}</span>
                        </FormItem>
                        <FormItem label="计划交货时间" prop="planDeliveryTime">
                            <span>{{item.planDeliveryTime | ymdL}}</span>
                        </FormItem>
                        <FormItem label="实际货时间" prop="realDeliveryTime">
                            <span>{{item.realDeliveryTime | ymdL}}</span>
                        </FormItem>
                        <FormItem label="备注" prop="remark" :marginBottom="20">
                            <span>{{item.remark}}</span>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="summary-title">》成本</div>
            <Form :label-width="100" :itemMarginBottom="0">
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="成本总价" prop="totalPrice">
                            <span>{{info.costList.length? info.costList[0].totalPrice : 0 }}</span>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="采购合同/单据" prop="invoice">
                            <preview-upload
                                :value="info.costList.length? info.costList[0].invoice : ''"
                                :showName="false"
                                readonly
                            ></preview-upload>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem label="客户验收单" prop="acceptInvoice">
                            <preview-upload
                                :value="info.costList.length? info.costList[0].acceptInvoice : ''"
                                :showName="false"
                                readonly
                            ></preview-upload>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>
        <!-- 其他 -->
        <div v-else>
            <div class="summary-title">》工作内容</div>
            <div class="summary-content">
                <div>{{info.content || '暂无'}}</div>
                <preview-upload v-model="info.attachments" :showName="false" readonly></preview-upload>
            </div>
        </div>
        <!-- problem字段 -->
        <div class="summary-title" v-if="picker.problemText">》{{picker.problemText}}</div>
        <div class="summary-content clearfix" v-if="picker.problemText">
            <div class="summary-content-check" v-for="(item,index) in problemList" :key="index">
                <common-icon
                    :size="16"
                    :color="item._checked? variables.linkColor: '#ccc'"
                    :type="item._checked? '_yixuan': '_weixuan'"
                />
                <span style="margin-left:5px">{{item.text}}</span>
            </div>
        </div>
        <!-- warranty字段 -->
        <div class="summary-title" v-if="picker.warrantyText">》{{picker.warrantyText}}</div>
        <div class="summary-content" v-if="picker.warrantyText">
            <div class="summary-content-check" v-for="(item,index) in warrantyList" :key="index">
                <common-icon
                    :size="16"
                    :color="item._checked? variables.linkColor: '#ccc'"
                    :type="item._checked? '_yixuan': '_weixuan'"
                />
                <span style="margin-left:5px">{{item.text}}</span>
            </div>
        </div>
        <!-- 内部 -->
        <div>
            <!-- 验收/巡检 -->
            <div v-if="serviceType == 'YS' || serviceType == 'XJ'">
                <div class="summary-title">》成本</div>
                <div class="summary-content">
                    <div v-if="!info.costList.length">暂无</div>
                    <Form :label-width="100" :itemMarginBottom="0">
                        <Row :gutter="20">
                            <Col
                                span="12"
                                v-for="(item, index) in info.costList"
                                :key="index"
                                style="margin-bottom: 20px"
                            >
                                <FormItem label="工具/仪器名称" prop="toolName">
                                    <span>{{item.toolName}}</span>
                                </FormItem>
                                <FormItem label="工具/仪器数量" prop="num">
                                    <span>{{item.num}}</span>
                                </FormItem>
                                <FormItem label="人工" prop="days">
                                    <span>{{item.days}}</span>
                                </FormItem>
                                <FormItem label="备注" prop="remark" :marginBottom="20">
                                    <span>{{item.remark}}</span>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
            <!-- 维修/保养 -->
            <div v-if="serviceType == 'WX' || serviceType == 'BY'">
                <div class="summary-title">》成本</div>
                <div class="summary-content">
                    <div v-if="!info.costList.length">暂无</div>
                    <Form :label-width="100" :itemMarginBottom="0">
                        <Row :gutter="20">
                            <Col span="12" v-for="(item, index) in info.costList" :key="index">
                                <FormItem
                                    :label="serviceType == 'WX'?'更换配件名称':'材料/设备名称'"
                                    prop="toolName"
                                >
                                    <span>{{item.toolName}}</span>
                                </FormItem>
                                <FormItem
                                    :label="serviceType == 'WX'?'更换配件型号':'材料/设备型号'"
                                    prop="toolModel"
                                >
                                    <span>{{item.toolModel}}</span>
                                </FormItem>
                                <FormItem
                                    :label="serviceType == 'WX'?'更换配件数量':'材料/设备数量'"
                                    prop="num"
                                >
                                    <span>{{item.num}}</span>
                                </FormItem>
                                <FormItem label="人工" prop="days">
                                    <span>{{item.days}}</span>
                                </FormItem>
                                <FormItem label="备注" prop="remark" :marginBottom="20">
                                    <span>{{item.remark}}</span>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
            <!-- 其他 -->
            <div v-if="serviceType == 'QT'">
                <div class="summary-title">》成本</div>
                <Form :label-width="100" :itemMarginBottom="0">
                    <Row :gutter="20">
                        <Col span="24">
                            <FormItem label="成本总价" prop="totalPrice">
                                <span>{{info.costList.length? info.costList[0].totalPrice : 0}}</span>
                            </FormItem>
                        </Col>
                        <Col span="24">
                            <FormItem label="成本费用清单" prop="invoice">
                                <preview-upload
                                    :value="info.costList.length? info.costList[0].invoice : ''"
                                    :showName="false"
                                    readonly
                                ></preview-upload>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
        </div>
    </div>
</template>
<script>
import { querySummary, exportWord } from '@/api/order-manage'
import PreviewUpload from '_c/preview-upload'
import Dict from '_u/dict'
import Enum from '_u/enum'
const SERVICE_TYPE = Enum.get('SERVICE_TYPE')
export default {
    name: 'FormOrderWaitInfo',
    props: {
        id: {
            type: [String, Number],
            default: ''
        },
        serviceType: {
            type: String,
            default: ''
        }
    },

    components: { PreviewUpload },

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            info: {
                id: this.id,
                orderDataSource: '', // 工单|任务
                acceptor: '',
                content: '',
                costList: [],
                createTime: '',
                createUserId: '',
                deliveryAddr: '',
                deliveryTime: '',
                execType: '',
                orderId: '',
                problem: [],
                purchaseList: [],
                remark: '',
                settleType: '',
                step: '',
                updateTime: '',
                updateUserId: '',
                warranty: [],
                serviceType: '', // 服务类别
                attachments: '', // 相关图片
                score: '', // 服务打分
                ver: '' // 版本号
            },
            dict: {
                serviceType: Dict.NULL,
                busType: Dict.NULL,
                orderStatus: Dict.NULL
            },
            picker: {
                problemText: '',
                warrantyText: ''
            },
            warrantyList: [],
            problemList: []
        }
    },

    computed: {
        dataSource() {
            return this.info.orderDataSource == 'G' ? '工单' : '任务'
        },
        serviceTypeList() {
            return this.dict.serviceType.val()
        }
    },

    methods: {
        fetch() {
            if (this.id) {
                return orderView(this.id)
            } else {
                return Promise.resolve()
            }
        },
        getSummary() {
            return querySummary(this.id)
                .then(res => {
                    let item = SERVICE_TYPE.getMeta(this.serviceType) || {}
                    return Promise.resolve().then(() => {
                        if (item.problemCode) {
                            return Promise.all([
                                Dict.get([item.problemCode, 'warranty']),
                                Promise.resolve(res)
                            ])
                        } else {
                            return Promise.all([
                                Dict.get(['warranty']),
                                Promise.resolve(res)
                            ])
                        }
                    })
                })

                .then(args => {
                    let [dictGroup, summary] = args
                    let problem = ''
                    let info = summary.data || {}
                    let item = SERVICE_TYPE.getMeta(this.serviceType) || {}
                    // 转数组, 回显
                    info.problem = info.problem ? info.problem.split(',') : []
                    info.warranty = info.warranty
                        ? info.warranty.split(',')
                        : []
                    if (item.problemCode) {
                        problem = dictGroup[item.problemCode]
                    }
                    Object.keys(this.info).forEach(key => [
                        (this.info[key] = info[key])
                    ])
                    let warrantyList = dictGroup.warranty.toList(),
                        problemList = problem ? problem.toList() : []
                    warrantyList.forEach(el => {
                        el._checked = info.warranty.includes(el.id)
                    })
                    problemList.forEach(el => {
                        el._checked = info.problem.includes(el.id)
                    })
                    this.warrantyList = warrantyList
                    this.problemList = problemList
                    this.picker = {
                        problemText: item.problemText,
                        warrantyText: item.warrantyText
                    }
                })
        },
        setBtn() {
            this.$modal.updateBtns([
                { type: 'primary', text: '导出文档', name: 'confirm' },
                { type: 'default', text: '关闭', name: 'cancel' }
            ])
        }
    },
    mounted() {
        var $info = this.$refs.info
        // 预加载
        this.$modal.beforeEnter(next => {
            this.getSummary().finally(() => {
                this.setBtn()
                next()
            })
        })
        // 导出
        this.$modal.onBtnClick('confirm', (next, options) => {
            var formData = Object.assign({}, this.info)
            this.$Modal.confirm({
                title: '导出确认',
                content: '是否包含成本？',
                okText: '包含',
                cancelText: '不包含',
                width: 400,
                onOk: () => {
                    let body = {
                        id: this.id,
                        containsCost: 1,
                        fileName: '工单总结'
                    }
                    exportWord(body)
                    next()
                },
                onCancel: () => {
                    let body = {
                        id: this.id,
                        containsCost: 0,
                        fileName: '工单总结'
                    }
                    exportWord(body)
                    next()
                }
            })
        })
    }
}
</script>
<style lang="less"
    scoped>
.summary-title {
    background-color: #eff2f9;
    padding: 10px;
    border-radius: 10px;
    color: @primary-color;
    font-weight: bold;
}
.summary-content {
    padding: 0 20px;
    line-height: 48px;
    &-check {
        display: inline-block;
        margin-right: 15px;
    }
}
.summary-content .dict-item {
    display: inline-block;
}
.summary-content .dict-item-text {
    margin: 0 20px;
}
.summary-primary-circle {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin-right: 10px;
    background-color: @primary-color;
    vertical-align: middle;
}
</style>
